export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (55346b07)";
export var GIT_SHA = "55346b07";
export var THEME = "default";
export var SYSTEM = "core";
export var ALWAYS_VISUAL_REFRESH = false;
export var INCLUDE_ONE_THEME = true;